module.exports = __webpack_public_path__ + "media/images/app/collections/colored-rings-491188131f70970aa673a0a81e04d8a0.webp";